// Firebase configuration for the auto-arb project.
// These are public client identifiers (not secrets) per Firebase documentation.
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
  apiKey: "AIzaSyCf2Q1-F-NC7iBEN3WjaD5Wh_zMLPckiEk",
  authDomain: "auto-arb.firebaseapp.com",
  projectId: "auto-arb",
  storageBucket: "auto-arb.firebasestorage.app",
  messagingSenderId: "396484930663",
  appId: "1:396484930663:web:7bb9dee6cf08a3e62478c2",
  databaseURL: "https://auto-arb-default-rtdb.firebaseio.com",
};

export default firebaseConfig;
